// extracted by mini-css-extract-plugin
export var dropdown = "_ts-0";
export var imageWrapper = "_ts-3";
export var itemNameContainer = "_ts-1";
export var productImage = "_ts-2";
export var spinnerWrapper = "_ts-4";